export default __webpack_public_path__ + "static/media/logo-horizontal-white.aef74587.png";